// extracted by mini-css-extract-plugin
export var root = "CMKI";
export var rootCategory = "kLFo";
export var rootDate = "_6-GQ";
export var rootDateHidden = "+536";
export var rootSmall = "_0fB5";